// @flow

const siteConfigs = (state: Object = { brandSiteConfig: {}, defaultSiteConfig: {} }) => state;

export default siteConfigs;
